import BaseElement from './BaseElement'
import { WishlistButton } from '../components/WishlistButton'

export default class WishlistButtonElement extends BaseElement {
  static get observedAttributes() {
    return ['product', 'variant-selected-id', 'template-suffix', 'product-bi-line', 'variant-selected', 'is-show-only-icon', 'product-personalised-price']
  }

  renderElement() {
    const product = this.getAttribute('product') && JSON.parse(this.getAttribute('product') as string)
    const variantSelected = this.getAttribute('variant-selected') && JSON.parse(this.getAttribute('variant-selected') as string)
    const productBiLine = this.getAttribute('product-bi-line') as string
    const variantSelectedId = parseInt(this.getAttribute('variant-selected-id') as string)
    const disableWishlist = this.getAttribute('disabled') as string
    const errorMessage = this.getAttribute('error-message') as string
    const templateSuffix = this.getAttribute('template-suffix') as string
    const isShowOnlyIcon = (this.getAttribute('is-show-only-icon') && (JSON.parse(this.getAttribute('is-show-only-icon') as string) as boolean)) || false
    const productPersonalisedPrice = this.getAttribute('product-personalised-price') && JSON.parse(this.getAttribute('product-personalised-price') as string)

    this.rootElement.render(
      <WishlistButton
        product={product}
        productBiLine={productBiLine}
        variantSelected={variantSelected}
        variantSelectedId={variantSelectedId}
        templateSuffix={templateSuffix}
        disableWishlist={disableWishlist}
        errorMessage={errorMessage}
        isShowOnlyIcon={isShowOnlyIcon}
        productPersonalisedPrice={productPersonalisedPrice}
      />
    )
  }
}
